"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./UserNav.css");

var _UserNavItem = _interopRequireDefault(require("./UserNavItem"));

var _Typography = _interopRequireDefault(require("../../Typography/Typography"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
Sub-component to display footer of user nav
*/
function UserNavFooter(_ref) {
  var version = _ref.version,
      credit = _ref.credit;
  if (!version && !credit) return null;
  return /*#__PURE__*/_react["default"].createElement(_UserNavItem["default"], {
    className: "st_usernav__footer"
  }, credit && /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    size: "sm",
    color: "ink",
    className: "st_usernav__credit"
  }, "Powered by ", credit), version && /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    color: "asphalt",
    size: "sm",
    margin: {
      top: 'xs'
    },
    className: "st_usernav__version"
  }, "Version ", version));
}

UserNavFooter.propTypes = {
  /** version of app to display */
  version: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /** credit line, e.g. Powered by Dow Jones */
  credit: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node])
};
UserNavFooter.defaultProps = {
  version: null,
  credit: null
};
UserNavFooter.displayName = 'HeaderBar.User.Footer';
var _default = UserNavFooter;
exports["default"] = _default;